<template>
	<div>
		<CubePage type="myorder-view" title="数据简报">
			<div slot="content">
				<van-sticky :offset-top="44">
					<van-tabs v-model="activeName">
						<van-tab title="标签 1" name="a"></van-tab>
						<van-tab title="标签 2" name="b"></van-tab>
						<van-tab title="标签 3" name="c"></van-tab>
						<van-tab title="标签 4" name="d"></van-tab>
						<van-tab title="标签 5" name="e"></van-tab>
						<van-tab title="标签 6" name="f"></van-tab>
						<van-tab title="标签 7" name="g"></van-tab>
					</van-tabs>
					<div class="cal-box">
						<div class="hd cal-sc">
							<div class="title">
								日期范围
							</div>
							<div class="tags">
								<van-button :class="selectcaltag=='本周'?'van-button-active':''"
									@click="onTagCalBtn('本周')" plain round size="mini">本周</van-button>
								<van-button :class="selectcaltag=='本月'?'van-button-active':''"
									@click="onTagCalBtn('本月')" plain round size="mini">本月</van-button>
								<van-button :class="selectcaltag=='近7天'?'van-button-active':''"
									@click="onTagCalBtn('近7天')" plain round size="mini">近7天</van-button>
								<van-button :class="selectcaltag=='近30天'?'van-button-active':''"
									@click="onTagCalBtn('近30天')" plain round size="mini">近30天</van-button>
								<van-button :class="selectcaltag=='今年'?'van-button-active':''"
									@click="onTagCalBtn('今年')" plain round size="mini">今年</van-button>
							</div>
						</div>
						<div class="cal-sc">
							<div class="cals" @click="calshow=true">
								<span class="ri" v-if="row.start_time">{{row.start_time}}</span>
								<span v-else style="color: #9e9e9e; font-size: 12px;">选择开始日期</span>
								<van-icon name="notes-o" size="25" />
							</div>
							<div class="dj">
								到
							</div>
							<div class="cals" @click="calshow=true">
								<span class="ri" v-if="row.end_time">{{row.end_time}}</span>
								<span v-else style="color: #9e9e9e; font-size: 12px;">选择结束日期</span>
								<van-icon name="notes-o" size="25" />
							</div>
						</div>
					</div>
				</van-sticky>

				<div style="z-index: -10;">
					<van-empty v-if="isNoData" class="custom-image" description="您还没有相关的数据">
						<template #image>
							<img src="@/assets/img/empty.png" alt="">
						</template>
					</van-empty>
					<van-list v-else v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad()"
						:immediate-check="false">
						<div class="orderitem van-clearfix" v-for="(item,index) in OrderList" :key="index"
							@click="goDetail($event,item.id)">
							<div class="ordertitle">
								<p>订单号：{{item.order_no}}</p>
								<p class="colorred">
									<span> {{item.order_status_text}}</span>
								</p>
							</div>
							<van-card :num="item.total_num + '张'" :title="item.goods_name" :thumb="item.goods_image">
								<template #price-top>
									<div class="carflex" style="padding: 5px 0;">
										<div>
											<div class="carddesc">
												<span>使用时间：</span>
												<span>{{item.use_date}}</span>
											</div>
											<div class="carddesc">
												<span>下单时间：</span>
												<span>{{item.createtime}}</span>
											</div>
										</div>
										<div v-if="item.order_status_text =='待确认'">
											<div class="btn-div zfbtn"
												style="height: 20px; line-height: 20px; width: 48px;"
												@click="goJieD(item.id)">
												<span>接单</span>
											</div>
											<div class="btn-div tkbtn"
												style="margin-top: 10px;height: 20px; line-height: 20px; width: 48px;"
												@click="goJuD(item.id)">
												<span>拒单</span>
											</div>
										</div>
									</div>
								</template>

								<template #footer>
									<div class="item">总价¥<span class="price">{{item.total_price}}</span></div>
									<div class="item blodspan">实付款¥<span class="price">{{item.pay_price}}</span></div>
								</template>
							</van-card>
						</div>
					</van-list>
				</div>
			</div>
		</CubePage>
		<cube-view></cube-view>
		<van-calendar v-model="calshow" type="range" @confirm="onConfirm" :allow-same-day="true" :min-date="minDate"
			:max-date="maxDate" />
	</div>
</template>


<script>
	import CubeView from '@/components/TP/cube-view'
	import CubePage from '../../../TP/cube-page.vue'
	import * as udate from '@/utils/date'
	import * as util from '@/utils/network'

	import {
		Dialog,
		Toast
	} from 'vant';
	export default {
		components: {
			CubePage,
			CubeView,
		},
		data() {
			return {
				loading: false,
				finished: false,
				OrderList: [],
				isNoData: false,
				gcfg: [],
				pageIndex: 1,
				pageTotal: 0,
				selectcaltag: '',
				calshow: false,
				minDate: new Date(2010, 0, 1),
				maxDate: new Date(),
				row: {
					status: '',
					search: '',
					start_time: '',
					end_time: ''
				},
				activeName: 'a'
			};
		},
		created() {
			this.gcfg = this.$store.getters.getGcfg
			this.get_my_order()
		},
		methods: {
			// 跳转详情页
			goDetail(event, id) {
				console.log(event.target)
				// 阻止a标签跳转
				event.preventDefault()
				if (event.target.outerText == '接单' || event.target.outerText == '拒单') {
					return;
				}
				this.$router.push({
					path: '/myorder/list/detail',
					query: {
						id: id
					}
				})
			},
			//接单
			goJieD(id) {
				Dialog.confirm({
						title: '温馨提示',
						message: '确认要接单操作吗？'
					}).then(() => {
						this.beforeClose(id, 0);
					})
					.catch(() => {
						// on cancel
					});;
			},
			//拒单
			goJuD(id) {
				Dialog.confirm({
						title: '温馨提示',
						message: '确认要拒单操作吗？'
					}).then(() => {
						this.beforeClose(id, -1);
					})
					.catch(() => {
						// on cancel
					});;
			},
			beforeClose(id, type) {
				let that = this;
				// 拒单
				var url = "/addons/litestore/api.supplier/orderRefuse"
				if (type == 0) { //接单
					url = "/addons/litestore/api.supplier/orderTaking"
				}
				let param = {
					id: id
				}
				//这里直接调用网络接口
				util.post(url, param,
					function(result) {
						console.log(result)
						Dialog.alert({
							title: '温馨提示',
							message: result.msg
						}).then(() => {
							that.onSearch()
						});
					},
				);
			},
			formatDate(date) {
				return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
			},
			onConfirm(date) {
				let that = this
				this.clearContainer();
				const [start, end] = date;
				that.calshow = false;
				that.row.start_time = that.formatDate(start);
				that.row.end_time = that.formatDate(end);
				that.get_my_order();
			},
			onTagCalBtn(v) {
				let that = this
				if (that.selectcaltag == v) {
					return;
				}
				this.clearContainer();
				let start = '';
				let end = '';
				let fmt = 'yyyy-MM-dd'
				start = udate.getDatenow(fmt);
				switch (v) {
					case '今天':
						end = that.GetDateStr(0, fmt);
						break;
					case '昨天':
						end = that.GetDateStr(-1, fmt);
						break;
					case '近7天':
						end = that.GetDateStr(-7, fmt);
						break;
					case '近30天':
						end = that.GetDateStr(-30, fmt);
						break;
					case '近两周':
						end = that.GetDateStr(-14, fmt);
						break;
					default:
						end = '';
						break;
				}

				that.row.start_time = end;
				that.row.end_time = start;
				that.selectcaltag = v
				that.get_my_order();
			},
			onTagBtn(v) {
				let that = this
				if (that.row.status == v) {
					return;
				}
				this.clearContainer();
				that.row.status = v
				that.get_my_order();
			},
			onSearch() {
				console.log(this.row.search)
				this.clearContainer();
				this.get_my_order();
			},
			// 上滑加载更多
			onLoad() {
				let that = this
				// 异步更新数据
				that.pageIndex++;
				setTimeout(() => {
					that.get_my_order();
				}, 1000)
			},
			// 获取数据
			get_my_order() {
				var url = "/addons/litestore/api.supplier/orderList"
				let that = this;
				that.row.page = that.pageIndex;
				//这里直接调用网络接口
				util.post(url, that.row,
					function(result) {
						that.loading = false;
						//这里对状态 进行分类 
						that.pageTotal = result.data.total
						if (that.pageTotal < 1) {
							that.isNoData = true
							return;
						}
						if (result.data.list == null || result.data.list.length === 0) {
							// 加载结束
							that.finished = true;
							return;
						}
						// 将新数据与老数据进行合并
						that.OrderList = that.OrderList.concat(result.data.list);

						//如果列表数据条数>=总条数，不再触发滚动加载
						if (that.OrderList.length >= that.pageTotal) {
							that.finished = true;
						}
					},
				);
			},
			GetDateStr(AddDayCount) {
				var day = new Date();
				day.setDate(day.getDate() + AddDayCount); //获取AddDayCount天后的日期
				var y = day.getFullYear();
				var m = day.getMonth() + 1; //获取当前月份的日期
				var d = day.getDate();
				m = String(m < 10 ? '0' + m : m);
				d = String(d < 10 ? '0' + d : d);
				let beg = y + "-" + m + "-" + d;

				return y + "-" + m + "-" + d;
			}, // 初始化数据
			clearContainer() {
				this.loading = false
				this.finished = false
				this.OrderList = []
				this.isNoData = false
				this.pageIndex = 1
				this.pageTotal = 0
			},
		}
	}
</script>
<style lang="less" type="text/css">
	.van-sticky {
		background: #fafafa !important;
	}
</style>
<style lang="less" scoped="scoped">
	@import url("../../../../assets/css/order.css");
	@import url("../../../../assets/css/listboxless.less");

	.van-search {
		.van-search__action {
			line-height: 0;
		}

		.van-button {
			height: 34px;
		}
	}

	.hd {
		background-color: #FFFFFF;
		width: 100%;
		overflow: scroll;
		padding-bottom: 10px;
		box-sizing: border-box;

		.tags {
			margin: 0 10px;
			box-sizing: border-box;
			display: flex;

			.van-button {
				flex-shrink: 0;
				// margin-right: 8px;
			}

			.van-button-active {
				border: 1px solid #55aa7f;
				color: #55aa7f;
			}
		}
	}

	.van-button--mini {
		padding: 0 10px !important;
	}

	// .van-sticky {
	// z-index: 999999;
	// background-color: #fff;

	.cal-box {
		background-color: #FFFFFF;
	}

	.cal-sc {
		margin-top: 10px;
		padding: 10px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		font-size: 14px;

		.title {
			color: #989898;
			padding-right: 10px;
		}

		.dj {
			margin: 0 5px;
		}

		.cals {
			.ri {
				font-weight: 600;
			}

			.van-icon {
				color: #55aa7f;
				margin-left: 10px;
				vertical-align: middle;
			}
		}

		// }

	}
</style>
<style type="text/css">
	.van-card {
		background: transparent !important;
	}
</style>
